module.exports = __webpack_public_path__ + "img/avatar.27456748.svg";